import { z } from 'zod';

export const CefeeScalarFieldEnumSchema = z.enum(['feeId','cityId','caseId','feeName','feeCharged','feePaid','dateFee','details','feeBy','dateFeeDue','feeData','rowTimestamp']);

export default CefeeScalarFieldEnumSchema;
